import { createFileRoute } from '@tanstack/react-router'
import AdminRunnersPage from '@/components/pages/Admin/AdminRunnersPage/AdminRunnersPage'

export const Route = createFileRoute('/$workspaceName/$environment/admin/runners')({
  component: AdminRunnersRoute,
})

function AdminRunnersRoute() {
  return <AdminRunnersPage />
}
